export const GOOGLE_KEY =
  "AIzaSyB0GFi-67ZL6_mTK-NjO-BvRIqm60tIsGU";
